// extracted by mini-css-extract-plugin
module.exports = {"QuizList":"_2oxZyK-l8VS_eA0Vf6jaEJ"};